/**
 * Generate a deep link (UI route) to the canonical page for a resource type.
 *
 * @param {string|null} resourceType  One of the AuditResourceTypeEnum string values
 * @param {{ project_id?: string|null, period_id?: string|null, report_type?: string|null, member_state?: string|null, page_url?: string|null }} ids
 * @returns {string|null}
 */
export function deepLink(
  resourceType,
  { project_id, period_id, report_type, member_state, page_url } = {}
) {
  if (!project_id) return null;

  switch (resourceType) {
    case 'fund':
      // AIFs management lives on the dedicated AddAIFs page now (was the
      // Funds page). The route handles both scratch and automation periods.
      return period_id
        ? `/project/quaters/${project_id}/${period_id}/add-aifs`
        : `/project/quaters/${project_id}`;

    case 'file':
      return period_id
        ? `/project/quaters/${project_id}/${period_id}/upload-files`
        : `/project/quaters/${project_id}`;

    case 'period':
      return `/project/quaters/${project_id}`;

    case 'workflow':
      return `/project/${project_id}`;

    case 'extraction':
    case 'automation':
      return period_id ? `/data-extraction/${project_id}/${period_id}` : null;

    case 'transformation':
      return period_id ? `/output-tables/${project_id}/${period_id}` : null;

    case 'report': {
      // Full report deep link requires report_type + member_state (FCA/ESMA report pages)
      if (period_id && report_type && member_state) {
        const base = `/report/${report_type}/${member_state}/${project_id}/${period_id}`;
        // Preserve fund_id query param when present in the originating page URL
        const fundId = page_url
          ? new URLSearchParams(page_url.split('?')[1] || '').get('fund_id')
          : null;
        return fundId ? `${base}?fund_id=${fundId}` : base;
      }
      // Fallback for automation-triggered runs (no report_type/member_state):
      // link back to the period list page where the Run button lives
      if (period_id) return `/project/quaters/${project_id}`;
      return null;
    }

    default:
      return null;
  }
}
